/* eslint-disable */

import React from 'react';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';
import qs from 'qs';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';

export const getPpcSettings = () => (dispatch) => {
  dispatch({ type: 'GET_PPC_SETTINGS_PENDING', payload: [] });
  return irelandApi.get('/api/admin/prepaid_card_settings')
    .then((response) => {
      const attributes = response.data.data.attributes;
      const firstDate = attributes['autoload-dates'].shift();
      const settings = {
        autoload_date: firstDate,
        autoload_dates: attributes['autoload-dates'],
        kyc_limit_euro: attributes['kyc-limit-euro'],
        load_fee_percent: attributes['load-fee-percent'],
        points_per_euro: attributes['points-per-euro'],
        ppc_management_url: attributes['ppc-management-url'],
        postcodeplan_redemption_date: attributes['postcodeplan-redemption-date'],
        postcodeplan_redemption_frequency: attributes['postcodeplan-redemption-frequency'],
        ngp_redemption_date: attributes['ngp-redemption-date'],
        ngp_redemption_frequency: attributes['ngp-redemption-frequency']
      };
      dispatch(actions.load('deep.admin_ppc.settings', settings));
      dispatch({ type: 'GET_PPC_SETTINGS_FULFILLED', payLoad: response.data });
    })
    .catch((error) => {
      dispatch({ type: 'GET_PPC_SETTINGS_REJECTED', payLoad: error.data });
      return Promise.reject(error.response.data);
    });
};

export const savePpcSettings = (payLoad) => {
  const data = {
    ...payLoad,
    autoload_dates: [payLoad.autoload_date, ...payLoad.autoload_dates]
  };
  delete data.autoload_date;
  return irelandApi.patch('/api/admin/prepaid_card_settings', {prepaid_card_setting: data})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Prepaid card settings saved successfully"/>);
      store.dispatch(actions.setValidity('deep.admin_ppc.settings', false));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save prepaid card settings"/>);
      store.dispatch(actions.resetValidity('deep.admin_ppc.settings'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(error.response.data.errors);
    });
};


export const getPpcManagementList = (query, dateFrom, dateTo, page = 1) => (dispatch) => {
  dispatch({type: 'GET_PPC_MANAGEMENT_LIST_PENDING', payload: []});
  const q = {
    text: query,
    opt_in_date_from: dateFrom,
    opt_in_date_to: dateTo,
  };
  return irelandApi.get(`/api/admin/ppc_users?${qs.stringify({q}, {encodeValuesOnly: true})}`, {params: {page}})
    .then((response) => {
      dispatch(actions.load('deep.admin_ppc.settings', response.data));
      dispatch({type: 'GET_PPC_MANAGEMENT_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_MANAGEMENT_LIST_REJECTED', payLoad: error.data});
      return Promise.reject(error.response.data);
    });
};

export const getPpcUser = id => (dispatch) => {
  dispatch({type: 'GET_PPC_USER_PENDING', payload: []});
  return irelandApi.get(`/api/admin/ppc_users/${id}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const data = {
        title: attributes.title,
        first_name: attributes['first-name'],
        last_name: attributes['last-name'],
        date_of_birth: attributes['date-of-birth'],
        address_1: attributes['address-1'],
        address_2: attributes['address-2'],
        town: attributes.town,
        county: attributes.county,
        eircode: attributes.eircode,
        kyc_status: attributes['kyc-status'],
        email: attributes.email,
        mobile: attributes.mobile
      };
      dispatch(actions.load('deep.admin_ppc.management.user', data));
      dispatch({type: 'GET_PPC_USER_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_USER_REJECTED', payLoad: error.data});
      return Promise.reject(error.response.data);
    });
};

export const getPpcUserLoads = (id, page = 1) => (dispatch) => {
  dispatch({type: 'GET_PPC_USER_LOADS_PENDING'});
  return irelandApi.get(`/api/admin/ppc_users/${id}/ppc_loads`, {params: {page}})
    .then((response) => {
      dispatch(actions.load('deep.admin_ppc.management.loads', response.data));
      dispatch({type: 'GET_PPC_USER_LOADS_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_USER_LOADS_REJECTED', payLoad: error.data});
      return Promise.reject(error.response.data);
    });
};

export const savePpcUser = (id, payLoad) => irelandApi.patch(`/api/admin/ppc_users/${id}`, {ppc_user: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Prepaid card user saved successfully"/>);
    history.push('/admin/ppc/management/');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save prepaid card user"/>);
    store.dispatch(actions.resetValidity('deep.admin_ppc.management.user'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const cancelPpcUserLoad = (userId, loadId) => (dispatch) => {
  dispatch({type: 'DELETE_PPC_USER_LOAD_PENDING'});
  return irelandApi.post(`/api/admin/ppc_users/${userId}/ppc_loads/${loadId}/cancel`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User load has been deleted successfully"/>);
      dispatch({type: 'DELETE_PPC_USER_LOAD_FULFILLED', payLoad: loadId});
      dispatch(getPpcUserLoads(userId));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during user load cancel"/>);
      dispatch({type: 'DELETE_PPC_USER_LOAD_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};

export const getPpcUserLoad = (userId, loadId) => (dispatch) => {
  dispatch({type: 'GET_PPC_USER_LOAD_PENDING', payload: []});
  return irelandApi.get(`/api/admin/ppc_users/${userId}/ppc_loads/${loadId}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const data = {
        points: attributes.points,
        value: attributes.value,
        status: attributes.status,
      };
      dispatch(actions.load('deep.admin_ppc.management.load', data));
      dispatch({type: 'GET_PPC_USER_LOAD_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_USER_LOAD_REJECTED', payLoad: error.data});
      return Promise.reject(error.response.data);
    });
};


export const savePpcLoad = (userId, loadId, payLoad) => irelandApi.patch(`/api/admin/ppc_users/${userId}/ppc_loads/${loadId}`, {ppc_load: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Prepaid card load saved successfully"/>);
    history.push(`/admin/ppc/management/${userId}`);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save prepaid card load"/>);
    store.dispatch(actions.resetValidity('deep.admin_ppc.management.load'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const getPpcUserManualLoad = userId => (dispatch) => {
  dispatch({type: 'GET_PPC_USER_MANUAL_LOAD_PENDING', payload: []});
  return irelandApi.get(`/api/admin/ppc_users/${userId}/ppc_manual_loads/new`)
    .then((response) => {
      dispatch({type: 'GET_PPC_USER_MANUAL_LOAD_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_USER_MANUAL_LOAD_REJECTED', payLoad: error.data});
      return Promise.reject(error.response.data);
    });
};

export const savePpcManualLoad = (userId, payLoad) => {
  const data = {
    ppc_manual_load: {
      points: parseInt(payLoad.points, 10)
    }
  };
  return irelandApi.post(`/api/admin/ppc_users/${userId}/ppc_manual_loads`, data)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Prepaid card load saved successfully"/>);
      history.push(`/admin/ppc/management/${userId}`);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save prepaid card load"/>);
      store.dispatch(actions.resetValidity('deep.admin_ppc.management.manual_load'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const convertPoints = (points, url, model) => (dispatch) => {
  dispatch({
    type: 'GET_PCC_LOAD_EUROS_PENDING',
    payload: []
  });
  return irelandApi.get(`${url}?points=${points}`)
    .then((response) => {
      dispatch({
        type: 'GET_PCC_LOAD_EUROS_FULFILLED',
        payLoad: response.data
      });
      const value = response.data.value || '0';

      dispatch(actions.change(model, value));
    })
    .catch((error) => {
      dispatch({
        type: 'GET_PCC_LOAD_EUROS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const deactivatePpcUser = id => (dispatch) => {
  dispatch({type: 'DEACTIVATE_PPC_USER_PENDING'});
  return irelandApi.post(`/api/admin/ppc_users/${id}/deactivate`)
  .then((response) => {
    dispatch({type: 'DEACTIVATE_PPC_USER_FULFILLED'});
    toast.success(<ToastMessage iconStyle="success" message="PPC User has been deactivated"/>);
    dispatch(getPpcManagementList('', '', '', 1))
  })
  .catch((error) => {
    dispatch({type: 'DEACTIVATE_PPC_USER_REJECTED'});
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during deactivation"/>);
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });
};

export const getPpcManagementUrl = () => (dispatch) => {
  dispatch({type: 'GET_PPC_MANAGEMENT_URL_PENDING', payload: []});
  return irelandApi.get('/api/prepaid_card_settings/ppc_management_url')
    .then((response) => {
      const ppc_management_url =  response.data.ppc_management_url;
      dispatch(actions.load('deep.ppc_management_url', ppc_management_url));
      dispatch({type: 'GET_PPC_MANAGEMENT_URL_FULFILLED', payLoad: ppc_management_url});
    })
    .catch((error) => {
      dispatch({type: 'GET_PPC_MANAGEMENT_URL_REJECTED', payLoad: error});
    });
};



// WEBPACK FOOTER //
// ./src/actions/ppc.js